import * as Yup from 'yup'

export const BidSchema = Yup.object({
  experience: Yup.string().trim().required('INPUT.VALIDATION.BID.EXPERIENCE'),
  pricing_type: Yup.string()
    .oneOf(['fixed_price', 'hourly_rate'], 'INPUT.VALIDATION.BID.PRICING_TYPE')
    .required('INPUT.VALIDATION.BID.PRICING_TYPE'),
  payment_terms: Yup.string().trim().required('INPUT.VALIDATION.BID.PAYMENT_TERMS'),
  bid_amount: Yup.string()
    .required('INPUT.VALIDATION.BID.AMOUNT')
    .test('is-number','INPUT.VALIDATION.BID.AMOUNT.NUMBER', (v) => {
      if (v === undefined || v === null || v === '') return false
      const n = Number(String(v).replace(/,/g, ''))
      return Number.isFinite(n)
    })
    .test('min-amount','INPUT.VALIDATION.BID.AMOUNT.MIN', (v) => {
      const n = Number(String(v).replace(/,/g, ''))
      return Number.isFinite(n) && n >= 100
    }),
  description: Yup.string().trim().required('INPUT.VALIDATION.BID.DESCRIPTION'),
})

export type BidSchemaType = Yup.InferType<typeof BidSchema>
